export default __webpack_public_path__ + "static/media/icon-values_2.bf47b64d.svg";